import { Button, Card, Flex, Form, Input, Space } from 'antd';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';

function ShopLoginMobile({ viewModel }) {
  const {
    token,
    form,
    loginError,
    shopInfo,
    navigate,
    handleContinue,
    onFinish,
  } = viewModel;

  return (
    <Card style={{ width: '100vw' }}>
      <Flex vertical gap={14}>
        <Space direction="vertical" align="center" style={{ textAlign: 'center' }}>
          <img alt="shop-logo" width={200} style={{ borderRadius: '8px' }} src={shopInfo.logo} />
          <span style={{ fontSize: token.fontSizeHeading3, fontWeight: '500' }}>{shopInfo.title}</span>
          <span>Log in to your account</span>
        </Space>

        <Form layout="vertical" form={form} initialValues={{}} onFinish={onFinish}>
          <Form.Item
            label="User name"
            name="user_name"
            validateTrigger="onBlur"
            rules={[
              {
                required: true,
                message: 'Bạn phải nhập user name',
              },
            ]}
          >
            <Input placeholder="Nhập user name"></Input>
          </Form.Item>

          <Form.Item
            label="Password"
            name="pass"
            rules={[
              {
                required: true,
                message: 'Password is required',
              },
            ]}
          >
            <Input.Password placeholder="Password" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
          </Form.Item>

          <Space direction="vertical" style={{ width: '100%' }} size={'large'}>
            {loginError && (
              <div style={{ float: 'right' }}>
                <span style={{ color: token.colorErrorText }}>{loginError.message}</span>
              </div>
            )}

            <div style={{ float: 'right' }}>
              <Button size="small" type="link" onClick={() => navigate('/reset-password')}>
                Forgot password?
              </Button>
            </div>

            <Button type="primary" style={{ width: '100%' }} onClick={handleContinue}>
              Đăng nhập
            </Button>
          </Space>
        </Form>
      </Flex>
    </Card>
  );
}

export default ShopLoginMobile;
